<template>
  <div class="cm-invoice-reminder-list-container dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddInvoiceReminderClick"
            class="dt-icon s1"
            src="static/buttons/add.svg"
            :title="$t('add_invoice')"
            :alt="$t('add_invoice')"
          />
        </div>
      </div>
    </div>
    <div class="invoice-reminder-list-container dt-page--body ut-h-full">
      <NTable
        class="invoice-reminder-list h1"
        :headers="invoiceHeaders"
        :items="list"
        :loadingFlag="loadingFlag"
        :config="tableConfig"
      >
        <template v-slot:item="{ tdcon, item }">
          <tr
            :title="$t('click_to_see_contact_details')"
            :class="{
              selected: selectedRow(item),
            }"
          >
            <td @click="onInvoiceReminderClicked(item)" v-bind="tdcon('date')">
              <span style="font-weight: 900">{{ item["date"] }}</span>
            </td>
            <td v-bind="tdcon('description')">
              <TextField2
                type="text"
                class="dbox1"
                id="subject"
                :showLabel="false"
                :disabled="false"
                :value="item['subject']"
                :bb="'0px'"
                @blur="(e) => onTextInputBlur(e, 'subject', item)"
              />
            </td>

            <td v-bind="tdcon('bank_checked')">
              <DatePicker2
                id="account_check_date"
                :showLabel="false"
                :value="item['account_check_date']"
                style="max-width: 115px"
                @valuechanged="
                  (name, value) =>
                    onInvoiceReminderBankDateChange(name, value, item)
                "
                lw="70px"
                cw="110px"
                :hoverStyle="1"
                :placeholder="''"
                :bb="'none'"
              />
              <!-- <DatePicker
                id="account_check_date"
                :value="item['account_check_date']"
                :controlType="'input'"
                @valuechanged="
                  (name, value) =>
                    onInvoiceReminderBankDateChange(
                      name,
                      value,
                      item
                    )
                "
              /> -->
            </td>
            <td v-bind="tdcon('invoice_info')">
              <span>
                {{ item["contacts"] }} Contacts /
                {{ item["invoices"] }} Invoices
              </span>
            </td>
            <td v-bind="tdcon('total')">
              <span>{{ item["total_amount"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => deleteInvoiceReminder(item)"
                class="dt-icon s2"
                alt=""
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <!-- <v-navigation-drawer v-bind="defaultConfig" :value="invoiceReminderDetailsFlag" touchless>
      <InvoiceReminderSidewindow
        @closeInvoiceReminderDetails="onCloseInvoiceReminderDetails"
      ></InvoiceReminderSidewindow>
    </v-navigation-drawer> -->
    <Sidewindow
      :value="invoiceReminderDetailsFlag"
      @closed="onCloseInvoiceReminderDetails"
    >
      <InvoiceReminderSidewindow></InvoiceReminderSidewindow>
    </Sidewindow>

    <ModalContainer :modalKey="'addInvoiceReminder'" :width="'small'">
      <AddInvoiceReminder @create="addNewReminder" @cancelled="onCancel" />
    </ModalContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime, window } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";
import DatePicker from "@plugins/text-field/date-picker";

import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { AccountingStoreNamespace as storeNS } from "../../store";
import {
  closeModalRoute,
  createModalMixin,
} from "../../../../dt-plugins/modal/modal.mixin";
import { mapKeyToAction } from "../../../../store/global";

import InvoiceReminderSidewindow from "./invoice-reminder-sidewindow";
import Sidewindow from "../../../../dt-plugins/sidewindow/sidewindow";
import AddInvoiceReminder from "./add-invoice-reminder.vue";
import { createCountriesTV } from "../../../../models/country.model";
import {
  subscribeSubject,
  sendMail,
  openMailWindow,
  openWindow,
} from "../../../../utility";
import { InvoicesService } from "../../services/invoices.service";
import {
  invoiceReminderListLDTRoutes,
  getInvoiceReminderDetailsSelectable,
} from "../../router/routes";
import { HttpClient } from "../../../../services/http/http-client";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

const listLength = 30;

const LDTConfig = {
  entityName: "invoice_reminder",
  ldtRoutes: invoiceReminderListLDTRoutes,
  detailsSelectableFunction: getInvoiceReminderDetailsSelectable,
  primaryKey: "invoice_reminder_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.SelectedInvoiceReminder.SET.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.SelectedInvoiceReminder.SET.SINGLE,
};

export default {
  components: {
    InvoiceReminderSidewindow,
    NTable,
    InputField,
    DatePicker,
    Sidewindow,
    AddInvoiceReminder,
    ModalContainer,
  },
  mounted: async function () {
    this.fetchData();
    this.fetchList();

    // this.$subscribeTo(
    //   this.searchSubject$.asObservable().pipe(
    //     debounceTime(200),
    //     distinctUntilChanged(),
    //   ),
    // searchString => {
    //   if (searchString.length > 0) {
    //     this.searchList(searchString);
    //   } else {
    //     this.fetchList();
    //   }
    // }
    // );

    subscribeSubject(this, this.searchSubject$, (searchString) => {
      if (searchString.length > 0) {
        // this.searchList(searchString);
        this.fetchList();
      }
    });
    subscribeSubject(this, this.scrollSubject$, (scrollTop) => {
      if (this.invoice_list_start_from == this.startFrom) {
        this.startFrom += listLength;
        this.fetchListNext();
      }
    });
  },
  data: function () {
    return {
      defaultConfig: defaultConfig,
      countries: [],
      groups: [],

      startRow: 0,

      searchSubject$: new Subject(),
      searchString: "",

      selectedInvoiceProject: null,
      selectedUser: null,
      selectedStatuses: null,

      startFrom: 0,
      scrollSubject$: new Subject(),

      LDTHostConfig: {
        itemKey: "invoice",
      },

      invoice_setstat: null,
      selectedClickedInvoiceReminder: null,

      tableConfig: createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      }),

      loadingFlag: false,
    };
  },
  mixins: [createLDTHost(LDTConfig), createModalMixin("addInvoiceReminder")],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      invoiceData: "invoiceData",
      invoice_projectsTV: "invoice_projectsTV",
      usersTV: "usersTV",
      invoice_statusTV: "invoice_statusTV",
      currencies: "currencies",
      list: "invoiceReminderList",
      selectedInvoiceReminder: "selectedInvoiceReminder",
      invoice_list_start_from: "invoice_list_start_from",
    }),
    invoiceHeaders: function () {
      return [
        createTableHeader("date", { fw: 200 }),
        createTableHeader("description"),
        createTableHeader("bank_checked", { mw: 115 }),
        createTableHeader("invoice_info", { text: "info" }),
        createTableHeader("total", {
          text: `${this.$t("total")} ${this.$t("amount")}`,
          ta: "right",
        }),
        createTableHeader("options", { text: false, mw: 30, ta: "center" }),
        // {
        //   value: "description",
        //   text: "Description",
        //   tkey: "description",
        // },
        // {
        //   value: "bank_checked",
        //   text: "Bank Checked",
        //   tkey: "Bank Checked",
        // },
        // { value: "info", text: "Info", tkey: "info" },
        // {
        //   value: "total",
        //   text: "Total Amount",
        //   tkey: `${this.$t("total")} ${this.$t("amount")}`,
        // },
        // { value: "options", text: "", tkey: `` },
      ];
    },
    invoiceReminderDetailsFlag: function () {
      return childOfOrEqualDetails(invoiceReminderListLDTRoutes, this.$route);
    },
    countriesTV: function () {
      return createCountriesTV(this.countries);
    },
    groupsTV: function () {
      return this.groups.map((g) => {
        return {
          text: g.group_name,
          value: g.group_id,
        };
      });
    },
    filter: function () {
      return {
        search_str: this.searchString,
        invoiceStatuses:
          this.selectedStatuses && this.selectedStatuses.length > 0
            ? this.selectedStatuses.map((e) => e.value).join(",")
            : undefined,
        invoice_project_id:
          this.selectedInvoiceProject && this.selectedInvoiceProject.value,
        invoice_user_id: this.selectedUser && this.selectedUser.value,
      };
    },
    paginatedFilter: function () {
      return {
        search_str: this.searchString,
        invoiceStatuses:
          this.selectedStatuses && this.selectedStatuses.length > 0
            ? this.selectedStatuses.map((e) => e.value).join(",")
            : undefined,
        invoice_project_id:
          this.selectedInvoiceProject && this.selectedInvoiceProject.value,
        invoice_user_id: this.selectedUser && this.selectedUser.value,
        start_from: this.startFrom,
      };
    },
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.InvoiceReminders.FETCH.ALL,
      ActionTypes.InvoiceReminders.UPDATE.SINGLE,
      ActionTypes.SelectedInvoiceReminder.SET.SINGLE,
      ActionTypes.InvoiceReminders.INSERT.SINGLE,
      ActionTypes.InvoiceReminders.DELETE.SINGLE,
      ActionTypes.InvoiceData.FETCH.ALL,
      ActionTypes.InvoiceList.FETCH.ALL,
      ActionTypes.InvoiceList.SEARCH.ALL,
      ActionTypes.LOCK_INVOICE,
    ]),
    onCancel: function () {
      closeModalRoute(this);
    },
    onAddInvoiceReminderClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_invoice_reminder",
        },
      });
    },
    fetchData: function () {
      this[ActionTypes.InvoiceData.FETCH.ALL]();
    },
    fetchList: async function () {
      this.loadingFlag = true;
      await this[ActionTypes.InvoiceReminders.FETCH.ALL]();
      this.loadingFlag = false;
    },
    fetchListNext: function () {},
    deleteInvoiceReminder: async function (item) {
      // console.log('deleteInvoiceReminder', item);

      const confirmationResult = await confirmDelete(
        "total amount",
        item.total_amount
      );
      if (confirmationResult === "OK") {
        console.log("ok");
        this[ActionTypes.InvoiceReminders.DELETE.SINGLE](item);
      }
    },
    onInvoiceReminderClicked: function (item) {
      this.selectedClickedInvoiceReminder = item;
      const { invoice_reminder_id } = item;
      this.$router.push({
        name: invoiceReminderListLDTRoutes.names.tab,
        params: {
          invoice_reminder_id,
          tab: "overview",
        },
      });
    },
    onTextInputBlur: function (event, name, item) {
      const value = event.target.value;
      this[ActionTypes.InvoiceReminders.UPDATE.SINGLE]({
        name,
        value,
        item,
      });
    },
    onInvoiceReminderBankDateChange: function (name, value, item) {
      this[ActionTypes.InvoiceReminders.UPDATE.SINGLE]({
        name,
        value,
        item,
      });
    },
    onCloseInvoiceReminderDetails: function () {
      this.selectedClickedInvoiceReminder = null;
      this.$router.push({
        name: invoiceReminderListLDTRoutes.names.list,
      });
    },
    selectedRow: function (invoiceReminder) {
      return (
        this.selectedClickedInvoiceReminder &&
        this.selectedClickedInvoiceReminder["invoice_reminder_id"] ===
          invoiceReminder["invoice_reminder_id"]
      );
    },

    addNewReminder: function (payload) {
      this.onCancel();
      this[ActionTypes.InvoiceReminders.INSERT.SINGLE](payload);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cm-invoice-reminder-list-container {
  .dt-ntable {
    // input{
    //   border:1px solid var(--sprt-5)
    // }

    @media (min-width: 320px) and (max-width: 480px) {
      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3) {
        display: none !important;
      }
    }
  }
}
</style>
